import { UserAuthWrapper } from 'redux-auth-wrapper';
import {
    loadingMeSelector,
    meSelector
} from 'common/permissions/selectors';
import {
    isAuthenticated
} from 'common/permissions/predicates';

export const UserIsAuthenticated = UserAuthWrapper({
    authSelector: meSelector,
    authenticatingSelector: loadingMeSelector,
    predicate: isAuthenticated,
    FailureComponent: null
});